export const theme = {
  main: "#415364",
  tertiary: '#9B552B',
  secondary: '#64513D'
};